export default __webpack_public_path__ + "static/media/opencart-negative.901ef1cc.svg";